var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHungryPatternMobile = function SvgHungryPatternMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 289,
    viewBox: "0 0 360 289",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.139 233.966C478.186 187.26 437.674 241.866 374.72 195.16C311.767 148.455 352.279 93.8494 289.326 47.1441C226.372 0.438774 185.86 55.044 122.907 8.33864C59.9535 -38.3667 100.465 -92.9722 37.5119 -139.678L132.715 -268C195.668 -221.295 155.156 -166.689 218.11 -119.984C281.063 -73.2784 321.575 -127.884 384.528 -81.1783C447.482 -34.473 406.97 20.1325 469.923 66.8378C532.877 113.543 573.389 58.9379 636.342 105.643L541.139 233.966Z",
    fill: "#FFF7E5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHungryPatternMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HungryPatternMobile.3d58b761.svg";
export { ForwardRef as ReactComponent };